import { render } from "./RecoveryForm.vue?vue&type=template&id=3ada03da&scoped=true&ts=true"
import script from "./RecoveryForm.vue?vue&type=script&lang=ts"
export * from "./RecoveryForm.vue?vue&type=script&lang=ts"

import "./RecoveryForm.vue?vue&type=style&index=0&id=3ada03da&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ada03da"]])

export default __exports__